<template>
  <body>
    <Navbar />
    <div class="container-fluid">
      <div class="row">
        <main
          role="main"
          class="col-md-12 ml-sm-auto col-lg-12 px-4 pb-5 mt-5 p-5"
        >
          <Navigation />
        </main>
      </div>
    </div>
  </body>
</template>
<script>
import Navbar from "@/components/Common/Navbar";
import Navigation from "@/components/Common/Navigation.vue";
export default {
  components: {
    Navigation,
    Navbar
  }
};
</script>
<style></style>
